import { inject, injectable } from 'inversify';

import { UserTenantAgnosticUnifiedRolesUpdateUserCase } from '../../domain/abstract';
import { UserServiceClientAdapter } from '../../infrastructure/adapters/UserServiceClient.adapter';

@injectable()
export class UserTenantAgnosticUnifiedRolesUpdateCommand extends UserTenantAgnosticUnifiedRolesUpdateUserCase {
  constructor(
    @inject(UserServiceClientAdapter)
    private readonly userServiceClientAdapter: UserServiceClientAdapter,
  ) {
    super();
  }

  public readonly execute: UserTenantAgnosticUnifiedRolesUpdateUserCase['execute'] =
    async (userPrincipal, payload) => {
      this.validateUseCase(userPrincipal);

      await this.userServiceClientAdapter.updateUserTenantAgnosticRoles({
        user: payload.user,
        tenant: payload.tenant,
        unifiedRoleCollectionDto: payload.unifiedRoles,
      });
    };
}
